module.exports = __webpack_public_path__ + "static/media/phone.55c96336.svg";